import {
  Component,
  computed,
  effect,
  inject,
  OnInit,
  Signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, ParamMap, Params, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { EventStoreService } from 'src/app/services/stores/event.store.service';
import { EventCounterStoreService } from 'src/app/services/stores/event-counter.store.service';
import { ShoutoutsStoreService } from 'src/app/services/stores/shoutouts.store.service';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
  standalone: false,
  providers: [
    EventStoreService,
    EventCounterStoreService,
    ShoutoutsStoreService,
  ],
})
export class EventComponent implements OnInit {
  private _router: Router = inject(Router);
  private _route: ActivatedRoute = inject(ActivatedRoute);
  private _shoutoutsStoreService = inject(ShoutoutsStoreService);
  private _queryParams: Signal<Params | undefined> = toSignal(
    this._route.queryParams,
  );
  private _params: Signal<ParamMap | undefined> = toSignal(
    this._route.paramMap,
  );
  protected eventCounterStoreService = inject(EventCounterStoreService);
  protected eventStoreService = inject(EventStoreService);
  protected sessionId: Signal<string | null> = computed(() => {
    const params = this._queryParams();
    return params && params['sessionId'] ? params['sessionId'] : null;
  });
  protected productId: Signal<string | null> = computed(() => {
    const params = this._queryParams();
    return params && params['productId'] ? params['productId'] : null;
  });
  protected eventId: Signal<string> = computed(
    () => this._params()?.get('eventId')!,
  );
  protected filterForm: FormGroup = new FormGroup({
    sessionId: new FormControl(null),
    productId: new FormControl(null),
  });
  protected shoutoutsToAnnounceCount: Signal<number> = computed(
    () => this._shoutoutsStoreService.shoutouts()?.length || 0,
  );

  constructor() {
    effect(() => {
      this.eventStoreService.getById(this.eventId());
      this.eventCounterStoreService.getById(this.eventId());
      this._shoutoutsStoreService.get(
        this.eventId(),
        this.sessionId(),
        true,
        false,
        false,
        false,
        this.productId(),
      );
      this.filterForm.setValue({
        sessionId: this.sessionId(),
        productId: this.productId(),
      });
    });
  }

  ngOnInit() {
    const eventId = this._route.snapshot.paramMap.get('eventId');
  }

  filterShoutouts() {
    this._router.navigate([], {
      relativeTo: this._route,
      queryParams: {
        sessionId: this.filterForm.value.sessionId,
        productId: this.filterForm.value.productId,
      },
      queryParamsHandling: 'merge',
    });
  }

  clearFilter() {
    this.filterForm.setValue({
      sessionId: null,
      productId: null,
    });
    this.filterShoutouts();
  }
}
